import React, { FC } from 'react'
import { AnnotationImage } from '../Popover.types'
import '../css/MobileAccordion.scss'
import { sanitizeHTML } from '../../../utils/common-utils'

type MobileAccordionProps = {
  annotationList: Array<AnnotationImage> | undefined
}

const MobileAccordion: FC<MobileAccordionProps> = props => {
  const { annotationList } = props
  if (!annotationList) {
    return null
  }
  const accordionItems = annotationList.map(currentAnnotation => {
    return (
      <details className='Accordion-item' key={currentAnnotation.id}>
        <summary
          className='Accordion-toggle'
          dangerouslySetInnerHTML={{
            __html: sanitizeHTML(currentAnnotation.heading),
          }}
        />
        <div className='Accordion-content Content'>
          <p
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(currentAnnotation.description),
            }}
          />
        </div>
      </details>
    )
  })

  return (
    <div className='Accordion Accordion--ruled Popover--Accordion u-block u-md-hidden u-lg-hidden u-marginVert4gu'>
      {accordionItems}
    </div>
  )
}
export default MobileAccordion
